// extracted by mini-css-extract-plugin
module.exports = {"container":"FoodModalOptions_container__2gcBu"};